var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-button text-left"},[_c('v-btn',{staticClass:"mb-2 primary--text",attrs:{"small":"","to":_vm.to || ''}},[_c('v-icon',{staticClass:"pr-2",attrs:{"size":"20"}},[_vm._v("mdi-arrow-left")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }